import { IPositionTrajectory, IUser } from '../../services/nextpeakClient'
import { markTrajectoryStepAsCompleted } from '../../utils'

const TrajectoryCounter = ({ employee, trajectoryItems }: { employee: IUser; trajectoryItems: IPositionTrajectory[] }) => {
	const markedItems = markTrajectoryStepAsCompleted(trajectoryItems, employee.userPosition!.positionTrajectory!.fromPosition!.id)

	return (
		<div className="flex gap-3 py-3">
			{markedItems.map((trajectory) => (
				<div
					key={trajectory.id}
					className={`inline-block flex-grow text-center font-bold rounded-md ${trajectory.isCompleted ? 'bg-success-500 text-white dark:text-white' : 'bg-gray-100 text-gray-700 dark:bg-white/5 dark:text-white/80'}`}
				>
					{trajectory.fromPosition!.level}
				</div>
			))}
		</div>
	)
}

export default TrajectoryCounter
